import { useState, useEffect } from 'react';
import type { UTSelectOptions } from '@group-link-one/gl-ui/utilities';
import type { PlatformVersion } from '@/Pages/BUs/BUManager/Components/BUPlatformList/BUPlatformList.types';
import { getTenantVersions } from '@/Pages/BUs/BUManager/Services/BUPlatform.service';

interface UseTenantVersionsOptions {
  tenantSlug: string;
}

export const useTenantVersions = ({ tenantSlug }: UseTenantVersionsOptions) => {
  const [versions, setVersions] = useState<PlatformVersion[]>([]);
  const [versionOptions, setVersionOptions] = useState<UTSelectOptions[]>([]);
  const [isLoadingVersions, setIsLoadingVersions] = useState(false);

  useEffect(() => {
    if (!tenantSlug) {
      setVersionOptions([]);
      setVersions([]);
      return;
    }

    setIsLoadingVersions(true);
    getTenantVersions(tenantSlug)
      .then(vs => {
        setVersions(vs);
        const opts: UTSelectOptions[] = vs.map((v, i) => ({
          id: String(i + 1),
          text: v.version + (v.name ? ` — ${v.name}` : '') + (v.isCurrent ? ' (current)' : ''),
          value: v.id,
        }));
        setVersionOptions(opts);
      })
      .catch(err => {
        // eslint-disable-next-line no-console
        console.error('Failed to fetch versions:', err);
        setVersionOptions([]);
        setVersions([]);
      })
      .finally(() => setIsLoadingVersions(false));
  }, [tenantSlug]);

  return { versions, versionOptions, isLoadingVersions };
};
